import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b803c40"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["name", "id", "value"]
const _hoisted_3 = {
  key: 0,
  class: "variaveis"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VariavelComponent = _resolveComponent("VariavelComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", { for: _ctx.selecaoId }, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        name: _ctx.selecaoId,
        id: _ctx.selecaoId,
        value: _ctx.selecao,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valores) = $event)),
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.alterarSelecao && _ctx.alterarSelecao(...args)))
      }, null, 40, _hoisted_2), [
        [_vModelCheckbox, _ctx.valores]
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.selecao.getLabel()), 1)
    ], 8, _hoisted_1),
    (_ctx.selecionado && _ctx.selecao.getVariaveis())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selecao.getVariaveis(), (variavel) => {
            return (_openBlock(), _createBlock(_component_VariavelComponent, {
              key: variavel.getId(),
              variavel: variavel,
              valor: variavel.getValor(),
              "onUpdate:valor": ($event: any) => (variavel.setValor($event))
            }, null, 8, ["variavel", "valor", "onUpdate:valor"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}